<template>
  <div class="container text-center pb-5 mt-5">
    <div class="mb-5">
      <section class="wrapper">
        <p>
          {{ $t('QR.RedirectMessage', { countdown: countdown }) }}
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      countdown: 0, // seconds before redirect
    };
  },
  mounted() {
    const interval = setInterval(() => {
      if (this.countdown > 1) {
        this.countdown--;
      } else {
        clearInterval(interval);
        this.$router.push('/');
      }
    }, 0);
  },
};
</script>
